export enum ProcessingStatusType {
    Pending = 1,
    InProgress,
    Complete,
    Error,
    Cancelled
}